module.exports = "/_next/static/images/Hero-ac273131be4baa464a8381aec5c9fe93.webp";